var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { Savable } from '@/common/mixins/Savable';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import SalaryTable from '@/template/components/aidApplication/budgetaryEstimate/expenses/SalaryTable.vue';
import LinesAndDetails from '@/common/components/LinesAndDetailsControl.vue';
import { FeatureConfiguration } from '@/common/types/FeatureConfiguration';
import LineControlWrapper from '@/common/types/LineControlWrapper';
import { InvestmentReportPersonnelExpenses } from '@/common/types/InvestmentReportPersonnelExpenses';
import LineControlConfig from '@/common/types/LineControlConfig';
import LineItemConfig from '@/common/types/LineItemConfig';
import AmountItemConfig from '@/common/types/AmountItemConfig';
var PersonnelExpensesControl = /** @class */ (function (_super) {
    __extends(PersonnelExpensesControl, _super);
    function PersonnelExpensesControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radioButtonValueChanged = "";
        return _this;
    }
    Object.defineProperty(PersonnelExpensesControl.prototype, "personnelExpenses", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PersonnelExpensesControl.prototype, "personnelExpensesWrapper", {
        get: function () {
            var e_1, _a;
            var showRowTotals = false;
            var showColumnTotals = true;
            var showActions = false;
            var maxRows = null;
            var config = new LineControlConfig(showRowTotals, showColumnTotals, showActions, function () { return null; }, maxRows);
            try {
                for (var _b = __values(this.personnelExpenses.yearlyPersonnelExpenses.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var line = _c.value;
                    var lineConfig = new LineItemConfig();
                    lineConfig.addAmountItemConfig(this.personnelExpenses.yearlyPersonnelExpenses.columnHeaders[0].value, new AmountItemConfig(null, { min_value: false }));
                    config.addLineItemConfig(line.key, lineConfig);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return new LineControlWrapper(this.personnelExpenses.yearlyPersonnelExpenses, config);
        },
        enumerable: false,
        configurable: true
    });
    PersonnelExpensesControl.prototype.onHasSalariedPersonnelChange = function (newValue, oldValue) {
        if (newValue) {
            if (this.personnelExpenses.salaryItems.length === 0) {
                this.addNewRow(this.personnelExpenses.salaryItems);
            }
        }
        else if (oldValue) {
            if (this.havePersonnelExpensesBeenModified()) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.SalariedPersonnel").toString())) {
                    this.clearPersonnelExpenses();
                }
                else {
                    this.personnelExpenses.hasSalariedPersonnel = true;
                    this.radioButtonValueChanged = Date();
                }
            }
            else {
                this.clearPersonnelExpenses();
            }
        }
    };
    PersonnelExpensesControl.prototype.havePersonnelExpensesBeenModified = function () {
        return this.haveSalaryItemsBeenModified() || this.haveOverallItemsBeenModified();
    };
    PersonnelExpensesControl.prototype.haveSalaryItemsBeenModified = function () {
        var items = this.personnelExpenses.salaryItems;
        return items.length > 1 || (items.length == 1 && this.hasSalaryItemBeenModified(items[0]));
    };
    PersonnelExpensesControl.prototype.hasSalaryItemBeenModified = function (salaryItem) {
        if (salaryItem.description
            || salaryItem.title
            || (salaryItem.grossSalary || salaryItem.grossSalary == 0)
            || (salaryItem.workingHours || salaryItem.workingHours == 0)
            || (salaryItem.workingHoursPercent || salaryItem.workingHoursPercent == 0)
            || salaryItem.isDivided)
            return true;
        return false;
    };
    PersonnelExpensesControl.prototype.haveOverallItemsBeenModified = function () {
        var e_2, _a;
        try {
            for (var _b = __values(this.personnelExpenses.yearlyPersonnelExpenses.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                var expense = _c.value;
                if (expense.description) {
                    return true;
                }
                var modifiableItem = expense.amountItems[0];
                if (modifiableItem.amount || modifiableItem.amount == 0) {
                    return true;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return false;
    };
    PersonnelExpensesControl.prototype.clearPersonnelExpenses = function () {
        var e_3, _a;
        try {
            for (var _b = __values(this.personnelExpenses.yearlyPersonnelExpenses.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                var expense = _c.value;
                expense.description = null;
                expense.amountItems[0].amount = null;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.personnelExpenses.salaryItems = [];
    };
    Object.defineProperty(PersonnelExpensesControl.prototype, "showSalaryItems", {
        get: function () {
            var showItems = this.personnelExpenses.hasSalariedPersonnel;
            if (showItems) {
                if (this.personnelExpenses.salaryItems.length === 0)
                    this.addNewRow(this.personnelExpenses.salaryItems);
            }
            return showItems;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PersonnelExpensesControl.prototype, "showDividedSalaryItems", {
        get: function () {
            var showItems = this.personnelExpenses.salaryItems.some(function (x) { return x.isDivided; });
            if (showItems) {
                if (this.personnelExpenses.dividedSalaryItems.length === 0)
                    this.addNewRow(this.personnelExpenses.dividedSalaryItems);
            }
            else {
                this.personnelExpenses.dividedSalaryItems = [];
            }
            return showItems;
        },
        enumerable: false,
        configurable: true
    });
    PersonnelExpensesControl.prototype.addNewRow = function (arr) {
        var item = {
            title: null,
            description: null,
            grossSalary: null,
            workingHours: null,
            workingHoursPercent: null,
            isDivided: false,
            personYear: null,
        };
        arr.push(item);
        this.forceSave();
    };
    var _a, _b;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof InvestmentReportPersonnelExpenses !== "undefined" && InvestmentReportPersonnelExpenses) === "function" ? _a : Object)
    ], PersonnelExpensesControl.prototype, "value", void 0);
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_b = typeof FeatureConfiguration !== "undefined" && FeatureConfiguration) === "function" ? _b : Object)
    ], PersonnelExpensesControl.prototype, "features", void 0);
    __decorate([
        Watch("personnelExpenses.hasSalariedPersonnel"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Boolean]),
        __metadata("design:returntype", void 0)
    ], PersonnelExpensesControl.prototype, "onHasSalariedPersonnelChange", null);
    PersonnelExpensesControl = __decorate([
        Component({
            name: "PersonnelExpensesControl",
            components: {
                RadioButtonRow: RadioButtonRow,
                TextAreaRow: TextAreaRow,
                SalaryTable: SalaryTable,
                LinesAndDetails: LinesAndDetails
            }
        })
    ], PersonnelExpensesControl);
    return PersonnelExpensesControl;
}(Mixins(Savable)));
export default PersonnelExpensesControl;
